import _ from '@triotech/vue-core/src/plugins/_';
import NotFound from '@/views/NotFound';
import ErrorPage from '@/views/Error';

import Login from '@/views/Login';
import Logout from '@/views/Logout';

import Module from '@/views/Module';
import Check from '@/views/Check';
import Help from '@/views/Help';
import Advertising from '@/views/Advertising';
import Test from '@/views/Test';
import Result from '@/views/Result';

export default [{
  path: '/',
  name: 'login',
  component: Login,
  props: _.queryPropsValidator.bind(_, Login),
}, {
  path: '/logout',
  name: 'logout',
  component: Logout,
}, {
  path: '/404/',
  name: 'not_found',
  component: NotFound,
}, {
  path: '/error/:code',
  name: 'error',
  component: ErrorPage,
  props: _.queryPropsValidator.bind(_, ErrorPage),
}, {
  path: '/check',
  name: 'check',
  component: Check,
}, {
  path: '/module/:token',
  name: 'module',
  component: Module,
  props: _.queryPropsValidator.bind(_, Module),
}, {
  path: '/help',
  name: 'help',
  component: Help,
}, {
  path: '/advertising',
  name: 'advertising',
  component: Advertising,
}, {
  path: '/test',
  name: 'test',
  component: Test,
}, {
  path: '/result',
  name: 'result',
  component: Result,
}];
